import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SubmitButton from './SubmitButton';
import translate from '../../../commonComponents/translate';

function MultipleChoice({ t, questionId, options, onSubmit, value }) {
  const [selectedAnswer, setSelectedAnswer] = useState(
    value ? value.multipleAnswers : [],
  );
  useEffect(() => setSelectedAnswer(value ? value.multipleAnswers : []), [
    questionId,
  ]);

  const handleSelection = answerId => () =>
    setSelectedAnswer(prev => {
      if (prev.includes(answerId)) {
        return prev.filter(id => id !== answerId);
      }
      return prev.concat(answerId);
    });

  const handleSubmit = () => onSubmit({ multipleAnswers: selectedAnswer });

  const answerButtonClass = answerId =>
    cx('quiz-answer-list-item', {
      selected: (selectedAnswer || []).includes(answerId),
    });

  return (
    <div className="m-portlet__body quiz-answers-container">
      <h4>{t('survey_multiple_answers_hint')}</h4>
      <div className="quiz-answer-list">
        {options.map(option => (
          <button
            key={option._id}
            type="button"
            className={answerButtonClass(option._id)}
            onClick={handleSelection(option._id)}
          >
            {option.option}
          </button>
        ))}
      </div>
      <SubmitButton
        onSubmit={handleSubmit}
        text={t('survey_pickAnswers')}
        disabled={selectedAnswer.length < 1}
      />
    </div>
  );
}

MultipleChoice.propTypes = {
  t: PropTypes.func.isRequired,
  questionId: PropTypes.string.isRequired,
  value: PropTypes.shape({
    multipleAnswers: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      option: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

MultipleChoice.defaultProps = {
  value: null,
};

export default translate(MultipleChoice);
